import { TriangleAlertIcon } from '@buffer-mono/popcorn'

import styles from './ExpiredTokenIndicator.module.css'

import type { JSX } from 'react'

export function ExpiredTokenIndicator(): JSX.Element {
  return (
    <span className={styles.indicator}>
      <TriangleAlertIcon size="xsmall" />
    </span>
  )
}
